import * as React from 'react';
import type { UpdateRedirectedProductsPayload } from 'contracts/redirected-products';
import { api } from 'services/api';

type UseUpdateRedirectedProductParams = {
  productId: number;
  payload: UpdateRedirectedProductsPayload;
};

export const useUpdateRedirectedProduct = () => {
  const updateRedirectedProduct = React.useCallback(async (params: UseUpdateRedirectedProductParams) => {
    await api.put(`/inventory/redirected-products/${params.productId}`, params.payload);
  }, []);

  return {
    updateRedirectedProduct,
  };
};